import type { Choice } from './index';

export const GAME_LAUNCH_MIN_MS = 60_000;
export const GAME_LAUNCH_MAX_MS = 120_000;
// Existing rounds created before variable scheduling get a 90-second interval.
export const GAME_LAUNCH_MS = 90_000;
export const GAME_VOTE_MS = 20_000;
export const GAME_ROUND_MS = 60_000;
export const GAME_SAMPLE_MS = 500;
export interface GameArt {
  name: string;
  symbol: string;
  image: string;
  hybrid?: boolean;
}
// No chart seed or future prices are sent to clients.
export interface SharedGameRound extends GameArt {
  id: string;
  visualSeed: number;
  start: number;
  cap: number;
  history: number[];
  choice: Choice | null;
  outcome: Choice | null;
  votes: number;
  votesUp: number;
}
export interface GameSnapshot {
  serverTime: number;
  rounds: SharedGameRound[];
  stats: { predictions: number; settled: number; wins: number; points: number };
}
